import { injectReducer } from '../../store/reducers'
import PatientDatabase from '../PatientDatabaseAdmin'
import PatientDetailAdmin from '../PatientDetailAdmin'

export default (store) => ({
  path: 'doctor/:id/patients',
  indexRoute: PatientDatabase(store),
  childRoutes: [
  	PatientDetailAdmin(store)
  ],
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const PatientAdmin = require('./containers/PatientAdminContainer').default;
      const reducer = require('./modules/patientAdmin').default;
      injectReducer(store, { key: 'patientAdmin', reducer });
      cb(null, PatientAdmin);
    }, 'patientAdmin')
  }
})


// WEBPACK FOOTER //
// ./src/routes/PatientAdmin/index.js